import React from 'react';
import TR from './../../Trans';
import List from '@mui/material/List';
import dayjs from 'dayjs';
import TrackListItem from './../items/TrackListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import DeleteIcon from '@mui/icons-material/Delete';
import accountStore from './../../stores/account';

function SingerListItem(props) {

  const [open, setOpen] = React.useState(false);

  const timeDiff = accountStore((state) => state.timeDiff);

  const handleClick = () => {
    setOpen(!open);
  };

  const trackStats = () => {
    if (props.trackStats) {
      if (props.trackStats.length > 0) {
        return props.trackStats.map((stat, index) => {
          return <TrackListItem sx={{ marginLeft: "1.2rem" }} key={index} track={stat.track}
            favorites={props.favorites}
            onAddPerformance={(e) => {
              e.stopPropagation();
              props.onAddPerformance(stat.track);
            }}
          />;
        });
      }
    }
    return <span>{TR.cm_no_history}</span>;
  };

  const renderCreated = () => {
    let date = new Date(props.created);
    date.setMinutes(date.getMinutes() - timeDiff);
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
  };

  const highlightText = (text) => {
    if (!props.highlight || !text) return text;

    const escaped = props.highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');

    return text.split(regex).map((part, i) =>
      part.toLowerCase() === props.highlight.toLowerCase()
        ? <span  className="muvika-filter-highlight" key={i}>{part}</span>
        : part
    );
  };

  return (
    <div>
      <ListItemButton onClick={handleClick}>
        <ListItemText
          primary={
            highlightText(props.name)
          }
          secondary={renderCreated()}
        />
        <IconButton color="white" component="label" size="large" onClick={props.openSingerEditDialog} >
          <EditIcon />
        </IconButton>
        <IconButton color="white" component="label" size="large" onClick={props.openDeleteDialog} >
          <DeleteIcon />
        </IconButton>
        <IconButton onClick={handleClick}>
          {open ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding className="muvika-list-performances">
          {trackStats()}
        </List>
      </Collapse>
    </div>
  );
}

export default SingerListItem;